import { TAPE_PANEL_MIN_HEIGHT } from './tapeUtils';

export default theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: TAPE_PANEL_MIN_HEIGHT,
  },
  canvasArea: {
    position: 'relative',
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'hidden',
    backgroundColor: '#101318',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
  },
  map: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
  },
  overlayWrap: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 500,
    touchAction: 'none',
  },
  svg: {
    position: 'absolute',
    left: 0,
    top: 0,
    display: 'block',
  },
  topOverlay: {
    position: 'absolute',
    left: 12,
    top: 12,
    right: 108,
    zIndex: 1100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
  },
  intentBar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '10px',
  },
  modeCols: {
    display: 'flex',
    gap: '8px',
  },
  modeCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  intentButton: {
    minWidth: 0,
    padding: '6px 14px',
    color: '#c8ccd4',
    borderColor: '#3a3f47',
    backgroundColor: 'rgba(30,34,40,0.9)',
  },
  intentButtonActive: {
    backgroundColor: '#ecece8',
    color: '#101318',
    '&:hover': {
      backgroundColor: '#d8d4c8',
    },
  },
  hud: {
    borderRadius: 4,
    backgroundColor: 'rgba(30,34,40,0.9)',
    color: '#ecece8',
    padding: '6px 12px',
    fontFamily: 'IBM Plex Mono, monospace',
    fontSize: 12,
    pointerEvents: 'none',
  },
  zoomBar: {
    position: 'absolute',
    right: 12,
    top: 12,
    zIndex: 1100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    padding: 4,
    backgroundColor: 'rgba(30,34,40,0.9)',
    borderRadius: 4,
    '& button': {
      color: '#ecece8',
    },
  },
  controlDivider: {
    width: '100%',
    height: 1,
    backgroundColor: '#3a3f47',
    margin: '2px 0',
  },
  bearingReadout: {
    fontFamily: 'IBM Plex Mono, monospace',
    fontSize: 11,
    color: '#c8ccd4',
    padding: '2px 0',
  },
  northIndicator: {
    position: 'absolute',
    left: '50%',
    top: 12,
    zIndex: 1050,
    width: 30,
    height: 30,
    marginLeft: -15,
    borderRadius: '50%',
    backgroundColor: 'rgba(30,34,40,0.9)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ff6b6b',
    pointerEvents: 'none',
  },
  deleteBtn: {
    position: 'absolute',
    zIndex: 1100,
    minWidth: 32,
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: '#2a2c2f',
    color: '#ecece8',
  },
});
